import { render, staticRenderFns } from "./HgiReflectionRecommendation.vue?vue&type=template&id=02534811"
import script from "./HgiReflectionRecommendation.vue?vue&type=script&lang=js"
export * from "./HgiReflectionRecommendation.vue?vue&type=script&lang=js"
import style0 from "./HgiReflectionRecommendation.vue?vue&type=style&index=0&id=02534811&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports